import PropTypes from 'prop-types';
import OrdersComponent from 'modules/shared/orders/components/OrdersComponent';

const OrdersContainer = props => <OrdersComponent {...props} />;

OrdersContainer.propTypes = {
  ordersList: PropTypes.shape({}).isRequired,
  mappedOrdersList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  orderStatusColorEnum: PropTypes.func.isRequired,
  stringsData: PropTypes.shape({}).isRequired,
};

OrdersContainer.defaultProps = {};

export default OrdersContainer;
